import React from 'react';

const states=[
    {value:"AL",Name:"Alabama"}, 
    {value:"AK",Name:"Alaska"},
    {value:"AZ",Name:"Arizona"},
    {value:"AR",Name:"Arkansas"},
    {value:"CA",Name:"California"},
    {value:"CO",Name:"Colorado"},
    {value:"CT",Name:"Connecticut"},
    {value:"DE",Name:"Delaware"},
    {value:"DC",Name:"District Of Columbia"},
    {value:"FL",Name:"Florida"},
    {value:"GA",Name:"Georgia"},
    {value:"HI",Name:"Hawaii"},
    {value:"ID",Name:"Idaho"},
    {value:"IL",Name:"Illinois"},
    {value:"IN",Name:"Indiana"},
    {value:"IA",Name:"Iowa"},
    {value:"KS",Name:"Kansas"},
    {value:"KY",Name:"Kentucky"},
    {value:"LA",Name:"Louisiana"},
    {value:"ME",Name:"Maine"},
    {value:"MD",Name:"Maryland"},
    {value:"MA",Name:"Massachusetts"}, 
    {value:"MI",Name:"Michigan"},
    {value:"MN",Name:"Minnesota"},
    {value:"MS",Name:"Mississippi"},
    {value:"MO",Name:"Missouri"},
    {value:"MT",Name:"Montana"},
    {value:"NE",Name:"Nebraska"},
    {value:"NV",Name:"Nevada"},
    {value:"NH",Name:"New Hampshire"},
    {value:"NJ",Name:"New Jersey"},
    {value:"NM",Name:"New Mexico"},
    {value:"NY",Name:"New York"},
    {value:"NC",Name:"North Carolina"},
    {value:"ND",Name:"North Dakota"},
    {value:"OH",Name:"Ohio"},
    {value:"OK",Name:"Oklahoma"},
    {value:"OR",Name:"Oregon"},
    {value:"PA",Name:"Pennsylvania"},
    {value:"RI",Name:"Rhode Island"},
    {value:"SC",Name:"South Carolina"},
    {value:"SD",Name:"South Dakota"},
    {value:"TN",Name:"Tennessee"},
    {value:"TX",Name:"Texas"},
    {value:"UT",Name:"Utah"},
    {value:"VT",Name:"Vermont"},
    {value:"VA",Name:"Virginia"},
    {value:"WA",Name:"Washington"},
    {value:"WV",Name:"West Virginia"},
    {value:"WI",Name:"Wisconsin"},
    {value:"WY",Name:"Wyoming"},
]

const StatesDropDown = (props) => {
    const { register, 
    } = props;

    return (
        <div className="form-group">
            <label htmlFor={props.htmlFor}>{props.label}<strong className="text-primary">*</strong></label>
            <select
                {...register(props.name, props.requiredObj)}
                className="custom-select" name={props.name} id={props.name}>
                <option value="">- Select Your State -</option>
                {states.map((state)=>(
                    <option value={state.value} key={state.value}>{state.Name}</option>
                ))}
                 
            </select>
            <small id={props.id} className="text-primary">
                {props?.errMsg}
            </small>
        </div>
    );
};

export default  StatesDropDown;